export default __webpack_public_path__ + "static/media/logo_grey.1093b27d.svg";